import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { CatalogProvider } from "./context/CatalogContext";
import { PlayerProvider, usePlayer } from "./context/PlayerContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import InstallPWA from "./components/InstallPWA";
import AudioPlayer from "./components/AudioPlayer";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import Browse from "./pages/Browse";
import BookDetail from "./pages/BookDetail";
import Library from "./pages/Library";
import Wishlist from "./pages/Wishlist";
import AuthorPage from "./pages/AuthorPage";
import NarratorPage from "./pages/NarratorPage";
import Auth from "./pages/Auth";
import Redeem from "./pages/Redeem";
import Account from "./pages/Account";
import SeriesPage from "./pages/SeriesPage";
import NotFound from "./pages/NotFound";
import { ForgotPassword, ResetPassword } from "./pages/ForgotPassword";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBooks from "./pages/admin/AdminBooks";
import AdminCollections from "./pages/admin/AdminCollections";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminRedemptions from "./pages/admin/AdminRedemptions";
import AdminBunny from "./pages/admin/AdminBunny";

function Shell({ children }) {
  const { current } = usePlayer();
  return (
    <div className="App grain flex flex-col min-h-screen">
      <Header />
      <main className={`flex-1 ${current ? "pb-24" : ""}`}>{children}</main>
      <Footer />
      <AudioPlayer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <CatalogProvider>
            <PlayerProvider>
              <Routes>
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/register" element={<Auth mode="register" />} />
                {/* Outside the shell, like the other auth screens: these are
                    one-task pages and the catalogue chrome is a distraction. */}
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route
                  path="/*"
                  element={
                    <Shell>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/browse" element={<Browse />} />
                        <Route path="/book/:id" element={<BookDetail />} />
                        <Route path="/author/:name" element={<AuthorPage />} />
                        <Route path="/narrator/:name" element={<NarratorPage />} />
                        <Route path="/series/:name" element={<SeriesPage />} />
                        <Route path="/library" element={<Library />} />
                        <Route path="/wishlist" element={<Wishlist />} />
                        {/* Both spellings: the emailed link carries the code,
                            a card or a forwarded message may not. */}
                        <Route path="/account" element={<Account />} />
                        <Route path="/redeem" element={<Redeem />} />
                        <Route path="/redeem/:code" element={<Redeem />} />
                        <Route path="/admin" element={<AdminLayout />}>
                          <Route index element={<AdminDashboard />} />
                          <Route path="books" element={<AdminBooks />} />
                          <Route path="collections" element={<AdminCollections />} />
                          <Route path="users" element={<AdminUsers />} />
                          <Route path="redemptions" element={<AdminRedemptions />} />
                          <Route path="bunny" element={<AdminBunny />} />
                        </Route>
                        {/* Last: anything unmatched. Without it the shell
                            rendered a header, a footer and nothing between. */}
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </Shell>
                  }
                />
              </Routes>
              <InstallPWA />
              <Toaster />
            </PlayerProvider>
          </CatalogProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
